import { render, staticRenderFns } from "./MinuteShowPage.vue?vue&type=template&id=4d1d24ec&"
import script from "./MinuteShowPage.vue?vue&type=script&lang=ts&"
export * from "./MinuteShowPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports